export default __webpack_public_path__ + "static/media/product-banner.fc480a38.webp";